export class InvalidTaxAmountError extends Error {
  constructor(json?: any) {
    super(json);
    Object.setPrototypeOf(this, InvalidTaxAmountError.prototype);
  }
}
